var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",staticClass:"t3m-ImageMap-video",attrs:{"src":_vm.video.url},on:{"timeupdate":_vm.track}})}
var staticRenderFns = []

export { render, staticRenderFns }